import { render } from "./ProductTagsMenu.vue?vue&type=template&id=9860e010&scoped=true&ts=true"
import script from "./ProductTagsMenu.vue?vue&type=script&lang=ts"
export * from "./ProductTagsMenu.vue?vue&type=script&lang=ts"

import "./ProductTagsMenu.vue?vue&type=style&index=0&id=9860e010&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9860e010"]])

export default __exports__